import { get, post} from './base';
export const AuthServ = {
    single: () =>{
       return get(`/auth/me`)
    },
    login: (payload) =>
        post('/auth/login', payload),
    register: (payload) =>
        post('/auth/register', payload),
}